import { ApiError } from "./api";
import type { MessageKey, Translate } from "./i18n";

/**
 * Server error codes → copy. Codes are the API's (`consumerLogin.ts`
 * ERROR_MESSAGES, `portalCheckout.ts`); anything unrecognised reads as the
 * generic failure, and a fetch that never reached the server as "offline".
 */
const CODES: Record<string, MessageKey> = {
  invalid_credentials: "auth.invalid",
  email_not_verified: "auth.notVerified",
  account_disabled: "auth.disabled",
  rate_limited: "auth.rateLimited",
  invalid_token: "auth.badLink",
  password_too_short: "auth.tooShort",
  password_too_long: "auth.tooLong",
  password_breached: "auth.breached",
  invalid_request: "auth.badRequest",
  invite_not_found: "auth.inviteGone",
};

export function errorText(
  err: unknown,
  t: Translate,
  overrides: Partial<Record<string, MessageKey>> = {}
): string {
  if (err instanceof ApiError) {
    const key = overrides[err.code] ?? CODES[err.code];
    return key ? t(key) : t("common.error");
  }
  return t("common.offline");
}

export function codeOf(err: unknown): string {
  return err instanceof ApiError ? err.code : "";
}

export function statusOf(err: unknown): number {
  return err instanceof ApiError ? err.status : 0;
}
